import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=0c205681&scoped=true"
import script from "./Lecture.vue?vue&type=script&lang=js"
export * from "./Lecture.vue?vue&type=script&lang=js"
import style0 from "./Lecture.vue?vue&type=style&index=0&id=0c205681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c205681",
  null
  
)

export default component.exports